import { useRef } from 'react'

let nextTabButtonSvgClipId = 1

/**
 * Stable unique id for SVG clipPath / url(#…) refs. React before 18 has no useId().
 */
export function useTabButtonSvgClipPathId() {
  const idRef = useRef(null)
  if (idRef.current == null) {
    idRef.current = `tab-button-svg-clip-${nextTabButtonSvgClipId++}`
  }
  return idRef.current
}
